import { useContext } from "react";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import { getRandomIntInclusive } from "../../../../helpers";
import { useQueryClient } from "react-query";
import {
  useDeletePOMutation,
  useDownloadPOMutation,
  useUpdateFulfillmentPOMutation,
} from "../../../../hooks/api/mutations";

export const usePOShareDialog = ({ closeModal = () => {} }) => {
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const queryClient = useQueryClient();
  const { mutate: downloadPO, isLoading: isDownlaodingPo } =
    useDownloadPOMutation();
  const { mutate: deletePO, isLoading: isDeletingPO } = useDeletePOMutation();
  const {
    mutate: updateFulfillmentPOMutation,
    isLoading: isUpdatingFulfillment,
  } = useUpdateFulfillmentPOMutation();

  const handleDownloadPO = (PODetails) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 30));
    downloadPO(
      { id: PODetails?.id },
      {
        onSuccess: (res) => {
          window.open(res?.data?.data?.url);
          triggerToast(
            `P.O. with No.: ${PODetails?.po_number} downloaded successfully`,
            "success",
          );
          closeModal();
        },
        onSettled: () => {
          setRequestLoaderProgress(100);
        },
      },
    );
  };

  const handleDeletePO = (PODetails) => {
    deletePO(
      { id: PODetails?.id },
      {
        onSuccess: () => {
          triggerToast(
            `P.O. with No.: ${PODetails?.po_number} deleted successfully`,
            "success",
          );
          closeModal();
        },
      },
    );
  };

  const handleUpdateFulfillment = (PODetails, fulfillment_state) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 30));
    updateFulfillmentPOMutation(
      { id: PODetails?.id, data: { fulfillment_state } },
      {
        onSuccess: () => {
          triggerToast(
            `P.O. with No.: ${PODetails?.po_number} fulfillment updated successfully`,
            "success",
          );
          queryClient.invalidateQueries([
            "getPurchaseOrderDetails",
            `${PODetails?.id}`,
          ]);
        },
        onSettled: () => {
          setRequestLoaderProgress(100);
        },
      },
    );
  };

  return {
    isDownlaodingPo,
    isDeletingPO,
    isUpdatingFulfillment,
    handleUpdateFulfillment,
    handleDownloadPO,
    handleDeletePO,
  };
};
